import { __awaiter, __rest } from "tslib";
import { defineComponent, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { Mutations } from '@/store/enums/StoreEnums';
import { onMessageReceived, requestPermissionAndGetToken } from './core/config/FirebaseConfig';
import { useBroadcastChannel } from '@vueuse/core';
import { useToast } from 'vue-toastification';
import { Actions as ExportActions } from '@/store/enums/finance/ExportEnums';
export default defineComponent({
    name: 'app',
    setup() {
        const store = useStore();
        const { data } = useBroadcastChannel({ name: 'sw-messages' });
        const toast = useToast();
        onMounted(() => {
            store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);
            setInterval(() => {
                const dummyData = JSON.parse(localStorage.getItem('exportFile') || '[]');
                dummyData.map((data) => {
                    store.dispatch(ExportActions.GET_EXPORT_STATUS_FILE, data);
                });
            }, 10000);
        });
        onMessageReceived((payload) => __awaiter(this, void 0, void 0, function* () {
            const registration = yield navigator.serviceWorker.getRegistration();
            const _a = payload.data, { title, body, icon } = _a, restPayload = __rest(_a, ["title", "body", "icon"]);
            const notificationOptions = {
                body,
                icon: icon || '/img/icons/android-chrome-192x192.png',
                data: restPayload
            };
            if (registration) {
                if ('showNotification' in registration) {
                    registration.showNotification(title, notificationOptions);
                }
            }
            else {
                new Notification(title, notificationOptions);
            }
        }));
        requestPermissionAndGetToken(process.env.VUE_APP_FIREBASE_VAPID_KEY || '')
            .then((token) => {
            store.commit(Mutations.SET_FCM_TOKEN, token);
        })
            .catch((err) => {
            console.log('An error occurred while retrieving token or requesting permission. ', err);
        });
        watch(data, () => {
            if (data.value) {
                toast.info(`${data.value}`, {
                    showCloseButtonOnHover: true,
                    closeButton: 'button'
                });
            }
        });
    }
});
